import React from "react";
import { useRenderTracing } from "./useRenderTracing";
export var useTraceComponentRender = function(operationName, attributes, options) {
    var endTrace = useRenderTracing(operationName, attributes, options);
    React.useEffect(function() {
        endTrace(); // End the tracing when the component has finished rendering
    }, [
        endTrace
    ]);
};
